<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
      </b-col>

      <!-- Content Right -->
<!--      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
            @click="showFormModal(null)"
            class="px-3 text-capitalize"
            variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد رزرو
        </b-button>
      </b-col>-->
    </b-row>
    <div v-if="transactions">
      <div class="d-flex justify-content-between align-items-center">
        <per-page v-model="perPage" class="w-50" />
      </div>
      <b-row>
        <!--        <b-col sm="6" md="3" lg="2">
                  <per-page v-model="perPage" class="w-100" />
                </b-col>-->
        <b-col sm="12" md="7" lg="8">
          <search-reservations
              @searchBase="searchBase"
              :selectedFilter="selectedFilter"
              :submitLoading="searchBasesubmitLoading"
              :isSearchResult="isSearchResult"
              ref="ownersSearchComponent"
              class="w-100"
              v-model="searchInput"
          />
        </b-col>
      </b-row>

      <b-card body-class="p-0" class="mt-1">
        <table-head
            ref="transactionsTableHeadComponent"
            :items="tableHeadings"
            @sort="sort"
        />
        <b-row
            class="py-1 mx-1 border-bottom"
            v-for="transaction in transactions"
            :key="transaction.id"
        >

          <b-col class="d-flex align-items-center pl-0">
            {{transaction.id}}
          </b-col>

          <b-col class="d-flex align-items-center pl-0">
            <b-badge variant="primary" v-if="transaction.order.orderable_type===space">
              اقامتگاه
            </b-badge>
            <b-badge variant="primary" v-if="transaction.order.orderable_type===event">
              تفریحات
            </b-badge>
            <b-badge variant="primary" v-if="transaction.order.orderable_type===tour">
              تور گردشگری
            </b-badge>
            <b-badge variant="primary" v-if="transaction.order.orderable_type===car">
              ترانسفر
            </b-badge>
          </b-col>
          <b-col>
            <span v-if="transaction.bank_tracking_number">
                  {{transaction.bank_tracking_number}}
              </span>
            <span v-else>
                -----
              </span>
          </b-col>

          <b-col
              class="d-flex align-items-center pl-0"

          >
            {{transaction.order.orderable.name}}
          </b-col>

          <b-col
              class=""

          >
                 <span>
                <strong>میزبان : </strong>

              </span>
            <b-badge variant="dark">
              {{transaction.order.host.first_name+' '+transaction.order.host.last_name}}
            </b-badge>
            <br/>
            <span class="mt-1">
                <strong>شماره میزبان : </strong>

              </span>
            <b-badge variant="dark" style="direction: ltr">
              {{transaction.order.host.mobile.replace("+98","0")}}
            </b-badge>
            <br/>
            <span>
                <strong>مهمان : </strong>

              </span>
            {{transaction.user.full_name}}
          </b-col>
          <b-col class="d-flex align-items-center pl-0">
            <b-badge variant="success" v-if="transaction.order.orderable_type===space">
              {{numberFormat(transaction.order.prices.total_commission_host)}} تومان
            </b-badge>
            <b-badge variant="success" v-if="transaction.order.orderable_type===event">
              {{numberFormat(transaction.order.prices.total_pay_host_commission_host)}} تومان
            </b-badge>
            <b-badge variant="success" v-if="transaction.order.orderable_type===tour">
              {{numberFormat(transaction.order.prices.total_pay_host_commission_host)}} تومان
            </b-badge>
            <b-badge variant="success" v-if="transaction.order.orderable_type===car">
              {{numberFormat(transaction.order.prices.total_pay_host_commission_host)}} تومان
            </b-badge>
          </b-col>
          <b-col
              class=""
          >
              <span>
                <strong>
                  تاریخ رزرو :
                </strong>
                {{
                  new Date(transaction.created_at).toLocaleString("fa-IR", {
                    timeZone: "Iran",
                  })
                }}
              </span>
            <br/>
            <span>
                <strong>
                  تاریخ اجرا :
                </strong>
                <span v-if="transaction.order.orderable_type===space">
                 <b-badge variant="info" v-if="transaction.order.checkin">
                              {{
                     new Date(transaction.order.checkin)
                         .toLocaleString("fa-IR")
                         .split(",")[0]
                   }}
                </b-badge>
                </span>
                 <span v-if="transaction.order.orderable_type===event">
                   <b-badge variant="info" v-if="transaction.order.checkin">
                                        {{
                       new Date(transaction.order.checkin)
                           .toLocaleString("fa-IR")
                           .split(",")[0]
                     }}
                </b-badge>
                </span>
                 <span v-if="transaction.order.orderable_type===car">
                     <b-badge variant="info" v-if="transaction.order.checkin">
                                          {{
                         new Date(transaction.order.checkin)
                             .toLocaleString("fa-IR")
                             .split(",")[0]
                       }}
                </b-badge>
                </span>
                 <span v-if="transaction.order.orderable_type===tour">
                   <b-badge variant="info" v-if="transaction.order.created_at">
                                        {{
                       new Date(transaction.order.created_at)
                           .toLocaleString("fa-IR")
                           .split(",")[0]
                     }}
                </b-badge>
                </span>
              </span>
          </b-col>
          <b-col   class="">
            <b-badge variant="success">
              تسویه شده
            </b-badge>
          </b-col>
          <b-col class="">
            <b-button
                variant="flat-info"
                v-if="transaction.status === 'success'"
                class="font-weight-bolder"
                @click="showFormModal(transaction, 'document')"
            >
              <BIconFiles font-scale="1" />
            </b-button>

            <!--            <b-button variant="flat-info" class="font-weight-bolder">
                          <feather-icon icon="EyeIcon" size="20" />
                        </b-button>-->
            <!--            <b-button
                            @click="showFormModal(transaction)"
                            variant="flat-secondary"
                            class="font-weight-bolder"
                        >
                          <feather-icon icon="Edit2Icon" size="20" />
                        </b-button>-->
          </b-col>
        </b-row>
      </b-card>
      <pagination
          ref="transactionsPaginationComponent"
          v-model="page"
          :paginationData="paginationData"
      />
    </div>
    <b-sidebar
        width="650px"
        v-model="formModal"
        right
        backdrop
        shadow
        bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
                style="background-color: rgba(75, 75, 75, 0.12)"
                @click="formModal = false"
                variant="flat-dark"
                class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{
                editMode
                    ? "ویرایش سند تسویه حساب با میزبان"
                    : "ایجاد سند تسویه حساب با میزبان"
              }}
            </h3>
          </div>
        </div>
      </template>

      <b-container class="">
        <!--        <b-form-group class="mt-3">
                  <label for="document_name" class="text-capitalize"
                  >{{ $t("document_name") }}:</label
                  >
                  <b-form-input
                      id="document_name"
                      v-model="documentInput.name"
                      type="text"
                  />
                </b-form-group>-->
        <!--        <b-form-group class="mt-3">
                  <label for="document_pric" class="text-capitalize"
                  >{{ $t("document_pric") }}:</label
                  >
                  <b-form-input
                      id="document_pric"
                      v-model="documentInput.price"
                      type="text"
                  />
                </b-form-group>-->
        <b-form-group class="mt-3">
          <label for="bank_tracking_code" class="text-capitalize"
          >{{ $t("bank_tracking_code") }}:</label
          >
          <b-form-input
              id="bank_tracking_code"
              v-model="documentInput.bank_tracking_number"
              type="text"
          />
        </b-form-group>
        <b-form-group class="mt-3">
          <label for="document_desc" class="text-capitalize"
          >{{ $t("document_desc") }}:</label
          >
          <b-form-input
              id="document_desc"
              v-model="documentInput.document_desc"
              type="text"
          />
        </b-form-group>




        <!--        <label for="document_medias" class="text-capitalize mb-3"
                >{{ $t("document_medias") }}:</label
                >
                <div
                    v-for="(file, index) in documentInput.medias"
                    :key="'file_' + index"
                    class="w-100 d-flex"
                >
                  <b-form-file
                      accept=".zip,.rar,.7zip"
                      v-model="documentInput.medias[index]"
                      ref="file-input"
                  ></b-form-file>
                  &lt;!&ndash; <b-button variant="flat-danger"   @click="removeFile(index)"> <feather-icon icon="Trash2Icon" size="20" /></b-button> &ndash;&gt;
                </div>-->
        <!--        <b-button v-if="documentInput.mediaPath" block mt-2 variant="outline-primary">دانلود اسناد بارگذاری شده</b-button>-->
        <!-- <b-button @click="addNewFile" >افزودن سند دیگر</b-button> -->

        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
              class="text-capitalize mr-2"
              @click="formModal = false"
              variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitForm()">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
                  {{ $t("submit") }}
                </span>
          </b-button>
        </div>
      </b-container>



    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormRadio,
  BBadge,
  BIconCalendar,
  BIconFiles,
  BFormFile,
} from "bootstrap-vue";
import debounce from 'lodash/debounce';
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import SearchReservations from "@/components/SearchReservations.vue";

export default {
  components: {
    SearchReservations,
    BIconCalendar,
    BBadge,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    BFormRadio,
    BIconFiles,
    VueUploadMultipleImage,
    BFormFile,
  },
  data() {
    return {
      space: "App\\Models\\Residence",
      tour: "App\\Models\\Tour",
      car: "App\\Models\\Car",
      event: "App\\Models\\Experience",
      isSearchResult:false,
      selectedFilter:[],
      formType: "document",
      perPage: 10,
      page: 1,
      transactions: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      users: [],
      residences: [],
      statusPayment:[
        "pending",
        "success",
        "fail",
      ],
      typePayment: [
        "manual",
        "gateway",
        "card"
      ],

      cardBank: [
        "بانک صادرات ",
        "بانک پاسارگارد",
        "سایر بانک ها",
      ],
      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },

      orders:[],

      transactionInput: {
        name: "",
        slug: "",
        status: "active",
      },
      orderRequestInput:{
        id:"",
        user_id: "",
        order_id: "",
        paid:"",
        status:"",
        service_type:"",
        bank_type:"",
        price_type:"full_payment",
        prices: {
          pay_site:0,
          pay_area:0,
          visitor:0,
          commission_site:0,
          commission_host:0,
          guests:0,
          unit:0,
        },
        description:"",
      },
      documentInput: {
        user_id: "",
        order_id: "",
        name: "",
        price: "",
        bank_tracking_number: "",
        document_desc: "",
        medias: [[]],
      },
      editMode: false,
      formModal: false,
      submitLoading: false,

      tableHeadings: [
        {
          title: "کد رزرو",
          slug: "code",
          sortable: true,
        },
        {
          title: " نوع خدمات ",
          slug: "type",
          sortable: true,
        },
        {
          title: " کد پیگیری بانک ",
          slug: "bank",
          sortable: true,
        },
        {
          title: " عنوان خدمات ",
          slug: "title",
          sortable: true,
        },
        {
          title: " میزبان/مهمان ",
          slug: "host",
          sortable: true,
        },
        {
          title: " تسویه با میزبان ",
          slug: "payHost",
          sortable: true,
        },
        {
          title: "  تاریخ ",
          slug: "date",
          sortable: true,
        },
        {
          title: " وضعیت ",
          slug: "created_at",
          sortable: true,
        },
        {
          title: "actions",
          sortable: false,
        },
      ],
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getReservations();
    // this.getCompanies();
    this.getUrlParams();

    this.getUsers();
    this.getOrders();


  },

  created() {
    // Create a debounced version of the search handler
    this.debouncedGetReservations = debounce(this.getReservations, 500);
  },

  watch: {
    /*    searchInput(value) {
          this.page = 1;
          this.getReservations();
        },*/
    searchInput(value) {
      this.page = 1; // Reset the page to the beginning
      if (value.trim().length) { // Ensure there is actual input to search for
        this.debouncedGetReservations();
      }
    },
    perPage(value) {
      this.page = 1;
      this.getReservations();
    },
    page(value) {
      this.getReservations();
    },
  },
  methods: {
    getOrders(search, loading) {
      if (typeof this.usersCancelToken != typeof undefined) {
        this.usersCancelToken.cancel(
            "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.usersCancelToken = this.$http.CancelToken.source();

      let data = {
        search: this.searchInput,
        per_page: this.perPage,
        page: this.page,
        sort_by: this.sortBy,
        sort_dir: this.sortDir,
        paginate:true
      };
      const requestData = {
        method: "get",
        url: "/admin/all_order?orderable_type=residence",
        params: data,
        // cancelToken: this.usersCancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.orders = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getUsers(search, loading) {
      if (typeof this.usersCancelToken != typeof undefined) {
        this.usersCancelToken.cancel(
            "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.usersCancelToken = this.$http.CancelToken.source();

      let data = {
        search: search,
        per_page: 10,
        page: 1,
      };

      const requestData = {
        method: "get",
        url: "/admin/users/get_total_users",
        params: data,
        // cancelToken: this.usersCancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.users = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    numberFormat(number) {
      return  new Intl.NumberFormat().format(number)
    },
    getUrlParams() {
      if ("filter[service_name]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[service_name]`];
        this.selectedFilter.push("service_name");
      }
      if ("filter[status]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[status]`];
        this.selectedFilter.push("status");
      }
      if ("filter[host_mobile]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[host_mobile]`];
        this.selectedFilter.push("host_mobile");
      }
      if ("filter[host_name]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[host_name]`];
        this.selectedFilter.push("host_name");
      }
      if ("per_page" in this.$route.query) {
        this.perPage = Number(this.$route.query[`per_page`]);
        this.$refs.userPerPageComponent.perPage = this.perPage;
      }
      if ("page" in this.$route.query) {
        this.page = this.$route.query[`page`];
      }

    },

    searchBase(data) {
      this.selectedFilter = data.selectedFilter;

      this.searchInput = data.searchInput;

      this.isSearchResult = this.searchInput !== "" && data.type !== "delete";

      this.searchBasesubmitLoading = true;

      this.getReservations();
    },
    /*    searchBase(data) {
          console.log("data", data);
          this.selectedFilter = [];
          if (data.selectedFilter.length > 0) {
            data.selectedFilter.forEach((item) => {
              if (item == "service_name") {
                this.searchInput = data.searchInput;
              } else if (item == "status") {
                this.searchInput = data.searchInput;
              } else if (item == "host_mobile") {
                this.searchInput = data.searchInput;
              }
              else if (item == "host_name") {
                this.searchInput = data.searchInput;
              }
            });
            this.selectedFilter = data.selectedFilter;
          }
          this.searchBasesubmitLoading = true;
          if (this.searchInput) {
            this.isSearchResult = true;
          }
          if (data.type == "delete") {
            this.isSearchResult = false;
          }
          this.getReservations();
        },*/

    addNewFile() {
      this.documentInput.medias.push([]);
    },

    removeFile(index) {
      this.documentInput.medias.splice(index, 1);
    },
    formatnumber(newValue) {
      const result = newValue
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return result;
    },

    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getReservations();
    },

    async getReservations() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        "filter[service_name]": this.selectedFilter.includes("service_name")
            ? this.searchInput
            : "",
        "filter[status]": this.selectedFilter.includes("status")
            ? this.searchInput
            : "",
        "filter[host_mobile]": this.selectedFilter.includes("host_mobile")
            ? this.searchInput
            : "",
        "filter[host_name]": this.selectedFilter.includes("host_name")
            ? this.searchInput
            : "",

        paginate: true,
        //  this.searchInput,
        // per_page: this.perPage,
        page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/get_bank_null_transactions",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.transactions = data.data;
            this.paginationData = data.meta;
            this.searchBasesubmitLoading = false;
          })
          .catch((err) => {
            console.log(err);
            this.searchBasesubmitLoading = false;
          });
    },
    showConfirmModal(transaction) {
      this.$bvModal
          .msgBoxConfirm(
              "آیا از حذف رزرو مطمئن هستید ؟" + `: ${transaction.payment_id}.`,
              {
                title: this.$t("Please Confirm"),
                size: "sm",
                okVariant: "primary",
                okTitle: this.$t("Yes"),
                cancelTitle: this.$t("No"),
                cancelVariant: "outline-secondary",
                hideHeaderClose: false,
                centered: true,
              }
          )
          .then(async (confirmed) => {
            if (confirmed) {
              let transactionIndex = 0;
              this.transactions = await this.transactions.filter(
                  (transactionItem, index) => {
                    if (transactionItem.id == transaction.id) {
                      transactionIndex = index;
                    }
                    return transactionItem.id !== transaction.id;
                  }
              );

              const requestData = {
                method: "delete",
                url: `/admin/transactions/${transaction.id}`,
              };
              this.$http(requestData)
                  .then((response) => {
                    this.$bvToast.toast(
                        `رزرو: ${transaction.payment_id} با موفقیت حذف شد.`,
                        {
                          title: this.$t("Done"),
                          variant: "success",
                          solid: true,
                        }
                    );
                  })
                  .catch((err) => {
                    let message = this.$t("Unable to delete!");
                    if (
                        err.response &&
                        err.response.data &&
                        err.response.data.message
                    )
                      message = err.response.data.message;
                    this.$bvToast.toast(message, {
                      title: this.$t("Error"),
                      variant: "danger",
                      solid: true,
                    });
                    this.transactions.splice(transactionIndex, 0, transaction);
                  });
            }
          });
    },
    showFormModal(transaction, type) {
      if (type == "document") {
        this.formType = "document";
        this.editMode = true;
        this.documentInput = {
          //name: transaction.document_name,
         // price:transaction.document_price,
          bank_tracking_number:transaction.bank_tracking_number,
          document_desc:transaction.document_desc,
         // medias: [[]],
        //  mediaPath:transaction.document_media.path

        };
        this.transactionInput = {
          id: transaction.id,
          name: transaction.name,
          slug: transaction.slug,
          status: transaction.status,
        };
      } else {
        this.formType = "mainTransationInfo";
        if (transaction) {
          this.transactionInput = {
            id: transaction.id,
            name: transaction.name,
            slug: transaction.slug,
            status: transaction.status,
          };
          this.editMode = true;
        } else {
          this.transactionInput = {
            name: "",
            slug: "",
            status: "active",
          };
          this.editMode = false;
        }
      }
      this.formModal = true;
    },
    submitForm() {
      this.submitLoading = true;
      let formData = new FormData();
      if (this.formType == "document") {
     //   formData.append("document_name", this.documentInput.name);
      //  formData.append("document_price", this.documentInput.price);

        formData.append(
            "bank_tracking_number",
            this.documentInput.bank_tracking_number
        );
       // formData.append("document_media", this.documentInput.medias[0]);
        formData.append("document_desc", this.documentInput.document_desc);
      }

      const requestData = {
        method: this.editMode ? "post" : "post",
        url: this.editMode
            ? `/admin/transactions/update/${this.transactionInput.id}`
            : `/admin/transactions`,
        data: this.formType == "document" ? formData : this.transactionInput,
      };

      this.$http(requestData)
          .then((response) => {
            let message = "رزرو با موفقیت اضافه شد";
            if (this.editMode) message = "رزرو با موفقیت ویرایش شد";
            if(this.formType == 'document')  message = "سند میزبان با موفقیت اضافه شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });
            if (
                !this.editMode &&
                this.transactions &&
                this.transactions.length > 0
            ) {
              this.$refs.transactionsPaginationComponent.clear();
              // this.$refs.transactionsSearchComponent.clear();
              this.$refs.transactionsTableHeadComponent.clear();
              this.page = 1;
              this.searchInput = "";
              this.sortBy = "";
              this.sortDir = "";
            }

            this.submitLoading = false;
            this.formModal = false;
            this.getReservations();
          })
          .catch((err) => {
            let message = "خطا در ایجاد رزرو";
            if (this.editMode) message = "خطا در ویرایش رزرو";
            if(this.formType == 'document')  message = "خطا در ایجاد سند";
            if (err.response && err.response.data && err.response.data.message)
              message = err.response.data.message;

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
            this.submitLoading = false;
            console.log(err);
          });
    },


    submitTransactionForm() {
      if (this.submitLoading) return;
      /*
            let errorMessage = null;

            if (!errorMessage && !this.orderInput.name) {
              errorMessage = "لطفا نام سفارش را وارد کنید";
            }
            if (!errorMessage && this.orderInput.name.length < 2) {
              errorMessage = "نام سفارش نمی تواند کمتر از دو کاراکتر باشد";
            }
            if (!errorMessage && !this.orderInput.slug) {
              errorMessage = "لطفا اسلاگ سفارش را وارد کنید";
            }
             if (!errorMessage && this.orderInput.slug.length < 2) {
              errorMessage = "اسلاگ سفارش نمی تواند کمتر از دو کاراکتر باشد";
            }


            if (errorMessage) {
              this.$bvToast.toast(errorMessage, {
                title: this.$t("Error"),
                variant: "danger",
                solid: true,
              });
              return;
            }
      */

      this.submitLoading = true;

      const requestData = {
        method: "post",
        url: `/admin/transactions`,
        data: this.orderRequestInput,
      };
      this.$http(requestData)
          .then((response) => {
            let message = "سفارش با موفقیت اضافه شد";
            //  if (this.editMode) message = "سفارش با موفقیت ویرایش شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });
            /*     if (!this.editMode && this.orders && this.orders.length > 0) {
                   this.$refs.ordersPaginationComponent.clear();
                   // this.$refs.ordersSearchComponent.clear();
                   this.$refs.ordersTableHeadComponent.clear();
                   this.page = 1;
                   this.searchInput = "";
                   this.sortBy = "";
                   this.sortDir = "";
                 }*/

            this.submitLoading = false;
            this.formModal = false;
            //this.$router.back();
            //this.getReservations();
            window.location.reload();
          })
          .catch((err) => {
            let message = "خطا در ایجاد تراکنش";
            if (this.editMode) message = "خطا در ویرایش تراکنش";
            if (err.response && err.response.data && err.response.data.message)
              message = err.response.data.message;

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
            this.submitLoading = false;
            console.log(err);
          });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>


